import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, Tooltip } from '@material-ui/core';
import { theme } from 'theme';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const SortableSliderImg = ({
  preview,
  onRemove,
  index,
  clicked,
  tooltipText,
  id,
  hideDeleteBtn = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Translate.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    position: 'relative',
    zIndex: isDragging ? 1 : undefined,
    marginRight: '15px',
    marginTop: '5px',
    maxWidth: '63px',
    maxHeight: '63px',
  };
  return (
    <div style={{ ...style }} ref={setNodeRef} {...attributes}>
      {!hideDeleteBtn ? (
        <IconButton
          edge="end"
          size="small"
          style={{
            position: 'absolute',
            right: 0,
            top: 0,
            background: 'white',
            transform: 'translate(50%, -50%)',
          }}
          onClick={() => onRemove(index)}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
      <Tooltip title={tooltipText}>
        <img
          {...listeners}
          src={preview}
          alt="preview"
          style={{
            cursor: 'move',
            maxWidth: '100%',
            maxHeight: '100%',
            ...(clicked === index && {
              border: `2px solid ${theme.colors.primary.red}`,
            }),
          }}
        />
      </Tooltip>
    </div>
  );
};

export default SortableSliderImg;
